// @ts-nocheck

import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";

/**
 * TopBar webcomponent for product pages
 * Manages variant selection, price calculation, and cart operations
 *
 * @extends Component
 */
class TopBarComponent extends Component {
  /** @type {number[]} */
  #allWatchId = [
    8755927613602, 8755975323810, 8776267497634, 8703781437602, 8537894256802,
    8537894256802, 8556262752418, 8553955983522, 8564617805986, 8564616102050,
    8537285132450, 8537170084002, 8537899040930, 8553931374754, 8553934717090,
    8537174835362, 8537258557602, 8186639286434, 8186643251362, 8186645577890,
    8186324582562, 8186586333346, 8186459095202, 8242548572322, 8242712838306,
    8242802884770, 8242546081954,
  ];

  // productId => discountCode, freeGiftProductId
  #trackerMap = {
    8644398186658: "FREE-GTL1-BAND-BUNDLE,45756202516642",
    8384718373026: "FREE-S5-BAND-BUNDLE,45753681117346",
    8515015344290: "FREE-GTL2-BAND-BUNDLE,46306424815778",
    8384228262050: "FREE-GTL2-BAND-BUNDLE,46306424815778",
  };

  /** @type {Object} */
  elements = {};

  /** @type {boolean} */
  initialized = false;

  /** @type {boolean} */
  isPc = false;

  /** @type {Object} */
  totals = {
    base: 0,
    baseCompare: 0,
    bundles: {},
  };

  /** @type {any} */
  priceCache = new Map();

  /** @type {string} */
  moneyFormat = "";

  /** @type {string} */
  currencyCode = "";

  /** @type {string} */
  currencySymbol = "";

  /** @type {boolean} */
  showCurrency = false;

  /** @type {Object|null} */
  priceElements = null;

  /** @type {number|null} */
  baseProductId = null;

  connectedCallback() {
    super.connectedCallback();

    // 获取配置数据
    this.moneyFormat = this.dataset.moneyFormat || "";
    this.currencyCode = this.dataset.currencyCode || "";
    this.currencySymbol = this.dataset.currencySymbol || "";
    this.showCurrency = this.dataset.showCurrency === "true";
    this.baseProductId = this.dataset.productId
      ? Number(this.dataset.productId)
      : null;
    this.totals.base = this.dataset.basePrice
      ? Number(this.dataset.basePrice)
      : 0;
    this.totals.baseCompare = this.dataset.baseComparePrice
      ? Number(this.dataset.baseComparePrice)
      : 0;

    this.isPc = window.innerWidth > 768;

    // 延迟初始化，确保 DOM 已完全加载
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.initElements();
      });
    } else {
      // 使用 requestIdleCallback 延迟初始化非关键元素
      if (window.requestIdleCallback) {
        requestIdleCallback(() => this.initElements(), { timeout: 100 });
      } else {
        setTimeout(() => this.initElements(), 0);
      }
    }
  }

  /**
   * 初始化元素引用
   */
  initElements() {
    if (this.initialized) return;
    this.initialized = true;

    const variantChoose = this.querySelector(
      ".product-topbar .product-topbar-wrapper .left .variant"
    );

    this.elements = {
      section: this,
      nav_bar: document.querySelector(".tab-section-wrapper"),
      variantChoose: variantChoose,
      icon: variantChoose?.querySelector(".icon"),
      content: this.isPc
        ? this.querySelector(
            ".product-topbar .product-topbar-wrapper .left .content"
          )
        : this.querySelector(
            ".product-topbar .product-topbar-wrapper .left .content-mob"
          ),
      name: variantChoose?.querySelector(".name"),
      currentPrice: this.querySelector(
        ".product-topbar .product-topbar-wrapper .right .price-container .current_price .topbar-total"
      ),
      savePriceEl: this.querySelector(
        ".product-topbar .product-topbar-wrapper .right .price-container .save_price .topbar-save"
      ),
      variantInput: this.querySelector(".product-topbar .variant-input"),
      allLabels: document.querySelectorAll(
        ".product-information variant-picker label"
      ),
      backTop: document.querySelector(".back_top"),
      videoWindow: document.querySelector(".video-floating-window"),
      googleMerchantWidget: document.querySelector(
        "#google-merchantwidget-iframe-wrapper"
      ),
    };

    this.elements.allItems =
      this.elements.content?.querySelectorAll("li") || [];
    this.elements.currentPriceSpan =
      this.elements.currentPrice?.querySelector("span");
    this.elements.savePriceSpan =
      this.elements.savePriceEl?.querySelector("span");

    this.setupEventListeners();
    this.setupCartHandling();
    this.setupScrollHandling();
    this.handleUrlVariant();
  }

  /**
   * 设置事件监听器
   */
  setupEventListeners() {
    // 监听 bundle 事件
    window.addEventListener("bundle:toggle", (e) => {
      const d = e.detail || {};
      const key = d.key;
      if (!key) return;
      this.totals.bundles[key] = this.totals.bundles[key] || {
        price: 0,
        compare: 0,
        quantity: 1,
        checked: false,
      };
      this.totals.bundles[key].price = Number(d.price_cents || 0);
      this.totals.bundles[key].compare = Number(d.compare_cents || 0);
      this.totals.bundles[key].quantity = Number(d.quantity || 1);
      this.totals.bundles[key].checked = !!d.checked;
      this.totals.bundles[key].variantId =
        d.variantId || this.totals.bundles[key].variantId || null;
      this.totals.bundles[key].save = Number(d.save || 0);
      // 如果传了 currency，更新 currencySymbol
      if (d.currency) {
        this.currencySymbol = d.currency;
      }
      this.recalcAndRender();
    });

    window.addEventListener("bundle:update", (e) => {
      const d = e.detail || {};
      const key = d.key;
      if (!key) return;
      this.totals.bundles[key] = this.totals.bundles[key] || {
        price: 0,
        compare: 0,
        quantity: 1,
        checked: false,
      };
      this.totals.bundles[key].price = Number(
        d.price_cents || this.totals.bundles[key].price || 0
      );
      this.totals.bundles[key].compare = Number(
        d.compare_cents || this.totals.bundles[key].compare || 0
      );
      this.totals.bundles[key].quantity = Number(
        d.quantity || this.totals.bundles[key].quantity || 1
      );
      this.totals.bundles[key].checked =
        d.checked ?? this.totals.bundles[key].checked;
      this.totals.bundles[key].variantId =
        d.variantId || this.totals.bundles[key].variantId || null;
      this.totals.bundles[key].save = Number(d.save || 0);
      // 如果传了 currency，更新 currencySymbol
      if (d.currency) {
        this.currencySymbol = d.currency;
      }
      this.recalcAndRender();
    });

    // 监听变体事件：即时选中与更新后同步 TopBar UI（无递归）
    document.addEventListener(ThemeEvents.variantSelected, (e) => {
      try {
        // 优先从事件 detail 中拿变体 ID；若非变体 ID（可能是 optionValueId），则从触发组件内读取选中 input 的 data-variant-id
        let variantId = /** @type {any} */ (e)?.detail?.resource?.id || null;
        if (!variantId && e?.target instanceof Element) {
          const checked = e.target.querySelector(
            ".variant-option-input:checked, input[data-variant-id]:checked"
          );
          variantId = checked?.getAttribute("data-variant-id") || null;
        }
        if (!variantId) return;
        this.syncTopbarByVariantId(String(variantId));
      } catch {}
    });

    document.addEventListener(ThemeEvents.variantUpdate, (e) => {
      try {
        const variantId = /** @type {any} */ (e)?.detail?.resource?.id;
        if (!variantId) return;
        this.syncTopbarByVariantId(String(variantId));
      } catch {}
    });
  }

  /**
   * 处理变体选择器展开/收起
   */
  handleVariantToggle(event) {
    if (!this.elements.variantChoose) return;
    // 如果点击的是item（item有自己的on:click，不会触发这个方法），不处理
    if (event.target.closest(".item")) return;

    this.elements.variantChoose.classList.toggle("active");
    this.elements.content?.classList.toggle("active");
    if (this.elements.backTop) this.elements.backTop.classList.toggle("active");
    if (this.elements.videoWindow)
      this.elements.videoWindow.classList.toggle("active");
    if (
      this.elements.googleMerchantWidget &&
      !this.elements.googleMerchantWidget.classList.contains("hidden")
    ) {
      this.elements.googleMerchantWidget.classList.add("hidden");
    }
  }

  /**
   * 处理变体项点击
   */
  handleVariantItemClick(event) {
    const clickedLi = event.target.closest("li");
    if (!clickedLi || !this.elements.content) return;

    this.handleVariantClick(clickedLi);
  }

  /**
   * 处理变体点击
   */
  handleVariantClick(clickedLi) {
    const processVariant = () => {
      try {
        const variant = JSON.parse(clickedLi.getAttribute("data-vars"));

        // 先应用 UI 与价格（不触发递归）
        this.applyVariantUiFromLi(clickedLi);

        // 触发主变体选择（通过 input[data-variant-id] 而非按索引映射，避免错位与多次触发）
        const input = document.querySelector(
          `.product-information variant-picker input[data-variant-id="${variant.id}"]`
        );
        if (input && /** @type {HTMLInputElement} */ (input).checked !== true) {
          const scrollPos = window.scrollY;
          /** @type {HTMLInputElement} */ (input).checked = true;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          window.scrollTo(0, scrollPos);
        }
      } catch (error) {
        console.error("Error parsing variant data:", error);
      }
    };

    if (window.requestIdleCallback) {
      requestIdleCallback(processVariant, { timeout: 50 });
    } else {
      setTimeout(processVariant, 0);
    }
  }

  /**
   * 仅应用 TopBar 的 UI 与价格，不触发 variant-picker
   * @param {HTMLElement} li
   */
  applyVariantUiFromLi(li) {
    if (!li) return;
    let variant;
    try {
      variant = JSON.parse(li.getAttribute("data-vars") || "{}");
    } catch {
      return;
    }

    // 切换 active（同时处理 PC/Mobile 两类列表）
    const allLis = this.querySelectorAll(
      ".product-topbar .product-topbar-wrapper .left .choose-wrapper li"
    );
    allLis.forEach((item) => item.classList.remove("active"));
    li.classList.add("active");

    // 更新左侧展示信息
    if (this.elements.name && variant.title)
      this.elements.name.innerHTML = variant.title;
    if (this.isPc && this.elements.variantChoose) {
      const colorDom = this.elements.variantChoose.querySelector(".color");
      if (colorDom && variant.color)
        colorDom.style.backgroundColor = variant.color;
      const imgDom = this.querySelector(".product-topbar .selected-variants");
      if (imgDom && variant.image)
        /** @type {HTMLImageElement} */ (imgDom).src = variant.image;
    }
    if (this.elements.variantInput && variant.id) {
      this.elements.variantInput.value = variant.id;
    }

    // 更新价格并渲染
    if (variant.price_cents) {
      this.totals.base = Number(variant.price_cents);
      this.totals.baseCompare = Number(variant.compare_at_price_cents || 0);
      this.recalcAndRender();
    }
  }

  /**
   * 根据变体 ID 同步 TopBar 的 UI（不触发 variant-picker）
   * @param {string} variantId
   */
  syncTopbarByVariantId(variantId) {
    const allLis = this.querySelectorAll(
      ".product-topbar .product-topbar-wrapper .left .choose-wrapper li"
    );

    // 先找到一个匹配项用于读取 variant 数据并更新 UI
    /** @type {HTMLElement | null} */
    let firstMatched = null;
    for (const item of allLis) {
      try {
        const id = String(
          JSON.parse(item.getAttribute("data-vars") || "{}").id
        );
        if (id === variantId) {
          firstMatched = /** @type {HTMLElement} */ (item);
          break;
        }
      } catch {}
    }

    if (!firstMatched) return;

    // 应用 UI（会清理所有 active 并给一个 li 设 active）
    this.applyVariantUiFromLi(firstMatched);

    // 再为其他同 ID 的项（例如移动端/桌面端重复项）一并添加 active
    for (const item of allLis) {
      try {
        const id = String(
          JSON.parse(item.getAttribute("data-vars") || "{}").id
        );
        if (id === variantId) {
          item.classList.add("active");
        }
      } catch {}
    }
  }

  /**
   * 处理URL中的变体参数
   */
  handleUrlVariant() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const variantId = params.get("variant");
    if (!variantId) return;

    const liItems = this.isPc
      ? this.querySelectorAll(
          ".product-topbar .product-topbar-wrapper .left .content .choose-wrapper li"
        )
      : this.querySelectorAll(
          ".product-topbar .product-topbar-wrapper .left .content-mob .choose-wrapper li"
        );

    liItems.forEach((item) => {
      try {
        const id = JSON.parse(item.getAttribute("data-vars")).id;
        if (id == variantId) item.click();
      } catch (e) {
        console.error("Error parsing variant from URL:", e);
      }
    });
  }

  /**
   * 格式化价格（从分）
   */
  formatMoneyFromCents(cents, currencySymbol = null) {
    const symbol = currencySymbol || this.currencySymbol || "";
    const cacheKey = `${cents}_${symbol}`;
    if (this.priceCache.has(cacheKey)) {
      return this.priceCache.get(cacheKey);
    }

    const amount = (cents / 100).toFixed(2);
    const formatted = symbol ? `${symbol}${amount}` : amount;
    this.priceCache.set(cacheKey, formatted);
    return formatted;
  }

  /**
   * 格式化价格（带货币）
   */
  formatMoneyWithCurrency(cents, currencySymbol = null) {
    const symbol = currencySymbol || this.currencySymbol || "";
    const cacheKey = `${cents}_${this.showCurrency}_${symbol}`;
    if (this.priceCache.has(cacheKey)) {
      return this.priceCache.get(cacheKey);
    }

    const amount = (cents / 100).toFixed(2);
    let formatted;
    if (this.showCurrency && this.currencyCode) {
      formatted = `${symbol}${amount} ${this.currencyCode}`;
    } else {
      formatted = symbol ? `${symbol}${amount}` : amount;
    }
    this.priceCache.set(cacheKey, formatted);
    return formatted;
  }

  /**
   * 获取价格元素
   */
  getPriceElements() {
    if (!this.priceElements) {
      this.priceElements = {
        currentPrice: this.elements.currentPrice,
        savePriceEl: this.elements.savePriceEl,
        savePriceContainer: this.querySelector(
          ".product-topbar .product-topbar-wrapper .right .price-container .save_price"
        ),
      };
    }
    return this.priceElements;
  }

  /**
   * 重新计算并渲染价格
   */
  recalcAndRender() {
    let bundleTotal = 0;
    let bundleCompare = 0;
    let bundleSave = 0;
    const baseSave = this.totals.baseCompare - this.totals.base;

    Object.values(this.totals.bundles).forEach((b) => {
      if (!b.checked) return;
      bundleTotal += b.price * b.quantity;
      bundleCompare += (b.compare || 0) * b.quantity;
      bundleSave += b.save * b.quantity;
    });

    const grandTotal = this.totals.base + bundleTotal;
    const grandCompare = this.totals.baseCompare + bundleCompare;
    const save = Math.max(0, baseSave) + bundleSave;

    // 使用requestAnimationFrame优化DOM更新
    requestAnimationFrame(() => {
      const priceEls = this.getPriceElements();

      if (priceEls.currentPrice) {
        const formattedPrice = this.formatMoneyWithCurrency(grandTotal);
        priceEls.currentPrice.innerHTML =
          '<span class="money">' + formattedPrice + "</span>";
      }

      if (priceEls.savePriceEl && priceEls.savePriceContainer) {
        const formattedSave = this.formatMoneyWithCurrency(save);
        priceEls.savePriceEl.innerHTML =
          '<span class="money">' + formattedSave + "</span>";

        // 批量更新类名，减少重排
        if (save > 0) {
          priceEls.savePriceContainer.classList.add("active");
        } else {
          priceEls.savePriceContainer.classList.remove("active");
        }
      }
    });
  }

  /**
   * 检查购物车中是否已存在指定变体
   */
  isVariantInCart(variantId) {
    const cartItemRows = document.querySelectorAll(".cart-items__table-row");
    if (!cartItemRows || cartItemRows.length === 0) return false;

    return Array.from(cartItemRows).some((item) => {
      const itemVariantId = item.getAttribute("data-variant-id");
      return itemVariantId == variantId;
    });
  }

  /**
   * 获取应用的折扣码
   * @returns {string[]}
   */
  getAppliedDiscountCode() {
    const cartDiscounts = document.querySelectorAll(".cart-discount__pill");
    if (cartDiscounts.length === 0) {
      return [];
    }
    const discountCodes = Array.from(cartDiscounts).map((item) =>
      item.getAttribute("data-discount-code")
    );
    return discountCodes;
  }

  /**
   * 应用手表逻辑：如果加入的产品是手表，追加指定变体
   */
  async applyWatchLogic(isWatch, items) {
    if (!isWatch) {
      return items;
    }

    const watchVariantId = "45856526303394";
    const quantity = 1;

    // 检查购物车中是否已经存在该变体
    const alreadyInCart = this.isVariantInCart(watchVariantId);

    // 如果购物车中没有该变体，则添加到 items 中
    if (!alreadyInCart) {
      let appliedDiscountCode = this.getAppliedDiscountCode();
      appliedDiscountCode = appliedDiscountCode.filter(
        (item) => item !== "FREE-GIFT"
      );
      appliedDiscountCode.push("FREE-GIFT");
      const discountStr = appliedDiscountCode.join(",");
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ discount: discountStr }),
      });

      items.push({ id: Number(watchVariantId), quantity: quantity });
    }

    return items;
  }

  /**
   * 应用 tracker 逻辑：如果加入的产品是 tracker，应用折扣码并添加免费礼品
   */
  async applyTrackerLogic(isTracker, items) {
    if (!isTracker) {
      return items;
    }

    if (!this.baseProductId) {
      return items;
    }

    const freeGiftStr = this.#trackerMap[this.baseProductId];
    if (!freeGiftStr) {
      console.log("no free gift str", this.baseProductId);
      return items;
    }

    const discountCode = freeGiftStr.split(",")[0];
    const freeGiftProductId = freeGiftStr.split(",")[1];

    // 检查购物车中是否已经存在该变体
    const alreadyInCart = this.isVariantInCart(freeGiftProductId);

    // 如果购物车中没有该变体，则应用折扣码并添加到 items 中
    if (!alreadyInCart) {
      let appliedDiscountCode = this.getAppliedDiscountCode();
      appliedDiscountCode = appliedDiscountCode.filter(
        (item) => item !== discountCode
      );
      appliedDiscountCode.push(discountCode);
      const discountStr = appliedDiscountCode.join(",");
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ discount: discountStr }),
      });

      items.push({ id: Number(freeGiftProductId), quantity: 1 });
    }

    return items;
  }

  /**
   * 设置购物车处理
   */
  setupCartHandling() {
    const buyNowForm = this.elements.section?.querySelector(
      'form[action^="/cart/add"], form[action^="/cart/add.js"], form[action*="/cart/add"]'
    );
    if (!buyNowForm) return;

    // 缓存bundle blocks查询结果
    let bundleBlocksCache = null;
    const getBundleBlocks = () => {
      if (!bundleBlocksCache) {
        bundleBlocksCache = document.querySelectorAll(
          '[x-data^="bundle_product_"]'
        );
      }
      return bundleBlocksCache;
    };

    buyNowForm.addEventListener(
      "submit",
      async (evt) => {
        evt.preventDefault();

        // 立即显示加载状态，提升用户体验
        const submitBtn = buyNowForm.querySelector('button[type="submit"]');
        const originalText = submitBtn?.textContent;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = "Adding...";
        }

        try {
          // 使用requestIdleCallback处理非关键数据收集
          const processCartAdd = async () => {
            // 主商品
            let baseVariantId = null;
            const activeLabel = document.querySelector(
              ".product-information variant-picker input:checked"
            );
            if (activeLabel) {
              baseVariantId = activeLabel.getAttribute("data-variant-id");
            } else if (
              this.elements.variantInput &&
              this.elements.variantInput.value
            ) {
              baseVariantId = this.elements.variantInput.value;
            } else {
              baseVariantId = this.dataset.defaultVariantId;
            }

            const items = [];
            if (baseVariantId)
              items.push({ id: Number(baseVariantId), quantity: 1 });

            // 捆绑项（优先使用 totals.bundles 中的 variantId）
            const seen = new Set();
            Object.values(this.totals.bundles).forEach((b) => {
              if (!b.checked) return;
              if (b.variantId) {
                const vid = Number(b.variantId);
                if (!seen.has(vid)) {
                  items.push({ id: vid, quantity: Number(b.quantity || 1) });
                  seen.add(vid);
                }
              }
            });

            // 若有缺失 variantId 的勾选项，再从 DOM 兜底补齐，避免重复
            const bundleBlocks = getBundleBlocks();
            bundleBlocks.forEach((el) => {
              const checkbox = el.querySelector(".bundle-input");
              if (!checkbox || !checkbox.checked) return;
              let variantId = null;
              try {
                const dataChoose = el
                  .querySelector('[x-ref="select"]')
                  ?.getAttribute("data-choose");
                if (dataChoose) variantId = Number(dataChoose);
              } catch (e) {}
              const qtySpan = el.querySelector(".qty_selector .qty_value");
              const qty = qtySpan ? Number(qtySpan.textContent || 1) : 1;
              if (variantId && !seen.has(variantId)) {
                items.push({ id: variantId, quantity: qty });
                seen.add(variantId);
              }
            });
            const nowTime = new Date();
            const endTime = new Date("2025-12-02T16:00:00+08:00");
            if (nowTime <= endTime) {
              // 应用手表逻辑
              const isWatch = this.baseProductId
                ? this.#allWatchId.includes(this.baseProductId)
                : false;
              // await this.applyWatchLogic(isWatch, items);

              // 应用 tracker 逻辑
              const isTracker = this.baseProductId
                ? this.#trackerMap.hasOwnProperty(this.baseProductId)
                : false;
              await this.applyTrackerLogic(isTracker, items);
            }

            if (items.length === 0) {
              buyNowForm.submit();
              return;
            }

            // 异步获取sections信息
            const cartItemsComponents = document.querySelectorAll(
              "cart-items-component"
            );
            const sectionIds = Array.from(cartItemsComponents)
              .map((el) => el.dataset.sectionId)
              .filter(Boolean);
            const sectionsQuery = sectionIds.length
              ? `?sections=${encodeURIComponent(
                  sectionIds.join(",")
                )}&sections_url=${encodeURIComponent(location.pathname)}`
              : "";

            const res = await fetch(`/cart/add.js${sectionsQuery}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ items }),
            });

            if (!res.ok) {
              throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            }

            const resp = await res.json();

            // 使用requestAnimationFrame确保DOM更新在下一帧
            requestAnimationFrame(() => {
              document.dispatchEvent(
                new CustomEvent("cart:update", {
                  detail: {
                    resource: resp,
                    sourceId: "topbar-bundle",
                    data: {
                      source: "topbar-bundle",
                      sections: resp.sections,
                    },
                  },
                })
              );
            });
          };

          await processCartAdd();
        } catch (err) {
          console.error("Add bundle to cart failed", err);
          // 降级到原始表单提交
          buyNowForm.submit();
        } finally {
          // 恢复按钮状态
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        }
      },
      { capture: true }
    );
  }

  /**
   * 节流函数
   */
  throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastCall < delay) return;
      lastCall = now;
      return fn.apply(this, args);
    };
  }

  /**
   * 设置滚动处理
   */
  setupScrollHandling() {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      if (!this.elements.nav_bar || !this.elements.googleMerchantWidget) return;

      const currentScrollY = window.scrollY;
      const scrollDelta = Math.abs(currentScrollY - lastScrollY);

      // 如果滚动距离太小，跳过处理
      if (scrollDelta < 5) return;

      lastScrollY = currentScrollY;

      // 使用requestAnimationFrame确保滚动处理不阻塞渲染
      if (!ticking) {
        requestAnimationFrame(() => {
          const rect = this.elements.nav_bar.getBoundingClientRect();
          const distance_y = rect.top + this.elements.nav_bar.clientHeight;

          // 批量更新类名，减少重排
          if (distance_y < 100) {
            this.elements.googleMerchantWidget.classList.add("hidden");
          } else {
            this.elements.googleMerchantWidget.classList.remove("hidden");
          }

          ticking = false;
        });
        ticking = true;
      }
    };

    // 使用更激进的节流和passive监听器
    window.addEventListener("scroll", this.throttle(handleScroll, 100), {
      passive: true,
    });
  }
}

if (!customElements.get("topbar-component")) {
  customElements.define("topbar-component", TopBarComponent);
}
